import React, { useState } from 'react'
import SideContactButtons from './SideContactButtons'
import { faFacebookF, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.orbicabs';
const APP_STORE_URL = 'https://apps.apple.com/us/app/orbi-cabs/id6789555723';

const Footer = () => {
    const [linkCopied, setLinkCopied] = useState(false);
    const [appLinkCopied, setAppLinkCopied] = useState(false);

    const copyPlayStoreLink = async () => {
        try {
            await navigator.clipboard.writeText(PLAY_STORE_URL);
            setLinkCopied(true);
            window.setTimeout(() => setLinkCopied(false), 2000);
        } catch (err) {
            console.error(err);
            const input = document.createElement('input');
            input.value = PLAY_STORE_URL;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            setLinkCopied(true);
            window.setTimeout(() => setLinkCopied(false), 2000);
        }
    };

    const copyAppStoreLink = async () => {
        try {
            await navigator.clipboard.writeText(APP_STORE_URL);
            setAppLinkCopied(true);
            window.setTimeout(() => setAppLinkCopied(false), 2000);
        } catch (err) {
            console.error(err);
            const input = document.createElement('input');
            input.value = APP_STORE_URL;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            setAppLinkCopied(true);
            window.setTimeout(() => setAppLinkCopied(false), 2000);
        }
    };

    return (
        <>
            <section className="footer_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="footer_row">
                                <div className="row g-4">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="footer_col text-center text-md-start">
                                            <img src="/assets/img/all-images/logo-orbi-black-transparent.png" alt="Orbi cabs logo" height="70" />
                                            <div className="app_links mt-4">
                                                <Link to="#"
                                                    onClick={(e) => e.preventDefault()} data-bs-toggle="modal"
                                                    data-bs-target="#playStoreModal"><img
                                                        src="/assets/img/all-images/android-btn.png" alt="Download on Google Play" /></Link>
                                                <Link to="#"
                                                    onClick={(e) => e.preventDefault()} data-bs-toggle="modal"
                                                    data-bs-target="#appStoreModal"><img
                                                        src="/assets/img/all-images/apple-btn.png" alt="Download on the App Store" /></Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="row g-4">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                                <div className="footer_col">
                                                    <h4>Quick Links</h4>
                                                    <Link to="/">Home</Link>
                                                    <HashLink smooth to="/#ridesSection" className="nav-item nav-link"> Rides </HashLink>
                                                    <Link to="/faqs">FAQs</Link>
                                                    <Link to="/blogs">Blogs</Link>
                                                    <Link to="/reviews">Reviews</Link>
                                                    <Link to="/contact-us">Contact Us</Link>
                                                    <Link to="/partner">Partner With Us</Link>
                                                    <Link to="/term-conditions">Term & Conditions</Link>
                                                    <Link to="/privacy-policy">Privacy Policy</Link>
                                                    <Link to="/refund-policy">Refund Policy</Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                                <div className="footer_col">
                                                    <h4>Contact Us</h4>

                                                    <b>Phone Number:</b>
                                                    <br />
                                                    <Link to="tel:+917535051511">
                                                        +91 75 3505 1511
                                                    </Link>

                                                    <Link to="tel:+919041364870">
                                                        +91 90 4136 4870
                                                    </Link>

                                                    <b>Customer Support:</b>
                                                    <br />
                                                    <Link to="mailto:support@orbicabs.com">
                                                        support@orbicabs.com
                                                    </Link>

                                                    <b>Partner:</b>
                                                    <br />
                                                    <Link to="mailto:partner@orbicabs.com">
                                                        partner@orbicabs.com
                                                    </Link>
                                                </div>
                                                <div className="footer_col">
                                                    <h4>Follow us:</h4>
                                                    <Link to="https://www.facebook.com/orbicabs/" target="_blank" rel="noopener noreferrer" className="d-inline" style={{ textDecoration: 'none' }}>
                                                        <span className="btn btn-sm socialBtn ps-0">
                                                            <FontAwesomeIcon icon={faFacebookF} />
                                                        </span>
                                                    </Link>

                                                    <Link to="https://www.linkedin.com/company/orbicabs/" target="_blank" rel="noopener noreferrer" className="d-inline" style={{ textDecoration: 'none' }}>
                                                        <span className="btn btn-sm socialBtn">
                                                            <FontAwesomeIcon icon={faLinkedinIn} />
                                                        </span>
                                                    </Link>

                                                    <Link to="https://www.instagram.com/orbicabs" target="_blank" rel="noopener noreferrer" className="d-inline" style={{ textDecoration: 'none' }}>
                                                        <span className="btn btn-sm socialBtn">
                                                            <FontAwesomeIcon icon={faInstagram} />
                                                        </span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="copyright_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="copyright_col">
                                <p>Copyright © {new Date().getFullYear()} Orbicabs. All rights reserved. Powered by <Link
                                    to="https://inclusionsoft.com"><img src="/assets/img/all-images/new-logo.png" alt="Inclusionsoft logo" /></Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Side Contact Buttons  section */}
            <SideContactButtons />


            <div
                className="modal fade"
                id="playStoreModal"
                tabIndex="-1"
                aria-labelledby="playStoreModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ borderRadius: 16 }}>
                        <div className="modal-header border-0 pb-0 position-relative justify-content-center">
                            <h5 className="modal-title fw-bold text-center w-100" id="playStoreModalLabel">
                                Get Orbi on Google Play
                            </h5>
                            <button
                                type="button"
                                className="btn-close position-absolute"
                                style={{ right: 16, top: 16 }}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body text-center pt-2 pb-4">
                            <p className="text-muted mb-3" style={{ fontSize: 14 }}>
                                Scan the QR code or copy the app link
                            </p>
                            <div
                                className="d-inline-block p-3 rounded-3 border bg-white mb-3"
                                style={{ borderColor: '#e5e7eb', lineHeight: 0 }}
                            >
                                <QRCodeSVG
                                    value={PLAY_STORE_URL}
                                    size={180}
                                    level="M"
                                    marginSize={2}
                                    title="Orbi Cabs on Google Play"
                                />
                            </div>
                            <div className="mb-3">
                                <a
                                    href={PLAY_STORE_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-inline-block"
                                >
                                    <img
                                        src="/assets/img/all-images/android-btn.png"
                                        alt="Get it on Google Play"
                                        style={{ height: 48, width: 'auto' }}
                                    />
                                </a>
                            </div>
                            <div
                                className="d-flex align-items-center gap-2 mx-auto"
                                style={{ maxWidth: 440 }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    value={PLAY_STORE_URL}
                                    readOnly
                                    onFocus={(e) => e.target.select()}
                                    style={{ fontSize: 13 }}
                                    aria-label="Google Play store link"
                                />
                                <button
                                    type="button"
                                    className={`btn btn-sm text-nowrap ${linkCopied ? 'btn-success' : 'btn-dark'}`}
                                    onClick={copyPlayStoreLink}
                                    style={{
                                        borderRadius: 6,
                                        width: '32px',
                                        height: '32px',
                                        padding: 0,
                                        backgroundColor: linkCopied ? '#198754' : '#212529',
                                        borderColor: linkCopied ? '#198754' : '#212529',
                                        color: '#fff',
                                        fontSize: 13,
                                    }}
                                    title={linkCopied ? 'Copied!' : 'Copy link'}
                                    aria-label={linkCopied ? 'Copied' : 'Copy link'}
                                >
                                    <FontAwesomeIcon icon={linkCopied ? faCheck : faCopy} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                id="appStoreModal"
                tabIndex="-1"
                aria-labelledby="appStoreModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ borderRadius: 16 }}>
                        <div className="modal-header border-0 pb-0 position-relative justify-content-center">
                            <h5 className="modal-title fw-bold text-center w-100" id="appStoreModalLabel">
                                Get Orbi on App Store
                            </h5>
                            <button
                                type="button"
                                className="btn-close position-absolute"
                                style={{ right: 16, top: 16 }}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body text-center pt-2 pb-4">
                            <p className="text-muted mb-3" style={{ fontSize: 14 }}>
                                Scan the QR code or copy the app link
                            </p>
                            <div
                                className="d-inline-block p-3 rounded-3 border bg-white mb-3"
                                style={{ borderColor: '#e5e7eb', lineHeight: 0 }}
                            >
                                <QRCodeSVG
                                    value={APP_STORE_URL}
                                    size={180}
                                    level="M"
                                    marginSize={2}
                                    title="Orbi Cabs on App Store"
                                />
                            </div>
                            <div className="mb-3">
                                <a
                                    href={APP_STORE_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-inline-block"
                                >
                                    <img
                                        src="/assets/img/all-images/apple-btn.png"
                                        alt="Get it on App Store"
                                        style={{ height: 48, width: 'auto' }}
                                    />
                                </a>
                            </div>
                            <div
                                className="d-flex align-items-center gap-2 mx-auto"
                                style={{ maxWidth: 440 }}
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    value={APP_STORE_URL}
                                    readOnly
                                    onFocus={(e) => e.target.select()}
                                    style={{ fontSize: 13 }}
                                    aria-label="App Store link"
                                />
                                <button
                                    type="button"
                                    className={`btn btn-sm text-nowrap ${appLinkCopied ? 'btn-success' : 'btn-dark'}`}
                                    onClick={copyAppStoreLink}
                                    style={{
                                        borderRadius: 6,
                                        width: '32px',
                                        height: '32px',
                                        padding: 0,
                                        backgroundColor: appLinkCopied ? '#198754' : '#212529',
                                        borderColor: appLinkCopied ? '#198754' : '#212529',
                                        color: '#fff',
                                        fontSize: 13,
                                    }}
                                    title={appLinkCopied ? 'Copied!' : 'Copy link'}
                                    aria-label={appLinkCopied ? 'Copied' : 'Copy link'}
                                >
                                    <FontAwesomeIcon icon={appLinkCopied ? faCheck : faCopy} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
